import type { CmsApiRecentSalariesBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecentSalariesBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsRecentSalariesMapping: CmsBlockMapping<CmsApiRecentSalariesBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.FULL,
    Component: dynamic(
      () =>
        import('./CmsRecentSalariesBlock').then((m) => ({
          default: m.CmsRecentSalariesBlock,
        })),
      { strategy: 'always' },
    ),
  };
